(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('rpt-compendium-message', {
                parent: 'entity',
                url: '/rpt-compendium-message',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_ADMIN'],
                    pageTitle: 'RptCompendiumMessages'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rpt-compendium-message/rpt-compendium-messages.html',
                        controller: 'RptCompendiumMessageController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('rpt-compendium-message-detail', {
                parent: 'entity',
                url: '/rpt-compendium-message/{id}',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_ADMIN'],
                    pageTitle: 'RptCompendiumMessage'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rpt-compendium-message/rpt-compendium-message-detail.html',
                        controller: 'RptCompendiumMessageDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'RptCompendiumMessage', function ($stateParams, RptCompendiumMessage) {
                        return RptCompendiumMessage.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'rpt-compendium-message',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('rpt-compendium-message-detail.edit', {
                parent: 'rpt-compendium-message-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/rpt-compendium-message/rpt-compendium-message-dialog.html',
                        controller: 'RptCompendiumMessageDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['RptCompendiumMessage', function (RptCompendiumMessage) {
                                return RptCompendiumMessage.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, {reload: false});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('rpt-compendium-message.new', {
                parent: 'rpt-compendium-message',
                url: '/new',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/rpt-compendium-message/rpt-compendium-message-dialog.html',
                        controller: 'RptCompendiumMessageDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['CoreService', function (CoreService) {
                                return {
                                    lowMessage: null,
                                    normalMessage: null,
                                    highMessage: null,
                                    id: null,
                                    clinic: CoreService.getCurrentClinic()
                                };
                            }]
                        }
                    }).result.then(function () {
                        $state.go('rpt-compendium-message', null, {reload: 'rpt-compendium-message'});
                    }, function () {
                        $state.go('rpt-compendium-message');
                    });
                }]
            })
            .state('rpt-compendium-message.edit', {
                parent: 'rpt-compendium-message',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/rpt-compendium-message/rpt-compendium-message-dialog.html',
                        controller: 'RptCompendiumMessageDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['RptCompendiumMessage', function (RptCompendiumMessage) {
                                return RptCompendiumMessage.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('rpt-compendium-message', null, {reload: 'rpt-compendium-message'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('rpt-compendium-message.delete', {
                parent: 'rpt-compendium-message',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/rpt-compendium-message/rpt-compendium-message-delete-dialog.html',
                        controller: 'RptCompendiumMessageDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['RptCompendiumMessage', function (RptCompendiumMessage) {
                                return RptCompendiumMessage.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('rpt-compendium-message', null, {reload: 'rpt-compendium-message'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
    }

})();
